import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { LoggerService } from '../../core/services/logger.service';
import { NetworkStateService } from '../../core/services/network-state.service';
import { BackButtonComponent } from '../../shared/components/back-button/back-button.component';
import { CardContentComponent } from '../../shared/components/card/card-content.component';
import { CardHeaderComponent } from '../../shared/components/card/card-header.component';
import { CardTitleComponent } from '../../shared/components/card/card-title.component';
import { CardComponent } from '../../shared/components/card/card.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-network-activity',
  standalone: true,
  imports: [
    BackButtonComponent,
    CardComponent,
    CardHeaderComponent,
    CardTitleComponent,
    CardContentComponent,
    TranslatePipe,
  ],
  templateUrl: './network-activity.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './network-activity.component.css',
})
export class NetworkActivityComponent implements OnInit {
  private networkState = inject(NetworkStateService);
  private logger = inject(LoggerService).getLogger('network');

  readonly activityLog = signal<
    {
      timestamp: Date;
      previousState: string;
      newState: string;
      syncStatus?: string;
    }[]
  >([]);
  readonly loadingLog = signal(false);

  async ngOnInit() {
    await this.loadActivityLog();
  }

  async loadActivityLog() {
    this.loadingLog.set(true);
    try {
      const log = await this.networkState.loadActivityLogFromDb(50);
      this.activityLog.set(log);
    } catch (error) {
      this.logger.error('Failed to load activity log:', error);
    } finally {
      this.loadingLog.set(false);
    }
  }

  formatDate(dateString: string | Date): { date: string; time: string } {
    if (!dateString) return { date: '', time: '' };

    const dateObj = typeof dateString === 'string' ? new Date(dateString) : dateString;

    const date = dateObj.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });

    const time = dateObj.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short',
    });

    return { date, time };
  }
}
